import axios from "axios";
import config from "../../config";

export default {
  namespaced: true,
  state: {
    allMaterials: [],
    allGrades: [],
    allPublishers: [],
    allInflectionalForms: [],
    allSpeechParts: [],
    allUnits: [],
    allThemes: [],
    katsuyoIds: [],
  },

  mutations: {
    setAllMaterials(state, payload) {
      payload.allMaterials.forEach((x,index)=>{
        state.allMaterials[index] = {
          id:       x.id,
          text:     x.name,
          type:     x.id === config.searchType.PUBLISHER ? 'publisher' : 'getThrough',
          disabled: false
        }
      })
    },
    setAllGrades(state, payload) {
      payload.allGrades.forEach((x,index)=>{
        state.allGrades[index] = {
          value: x.id,
          text:  x.name
        }
      })
    },
    setAllPublishers(state, payload) {
      payload.allPublishers.forEach((x,index)=>{
        state.allPublishers[index] = {
          value: x.id,
          text:  x.name
        }
      })
    },
    setAllInflectionalForms(state, payload) {
      payload.allInflectionalForms.forEach((x,index)=>{
        state.allInflectionalForms[index] = {
          value: x.ids,
          text:  x.name
        }
        x.ids.forEach(id=>state.katsuyoIds.push(id))
      })
    },
    setAllSpeechParts(state, payload) {
      payload.allSpeechParts.forEach((x,index)=>{
        state.allSpeechParts[index] = {
          value: x.ids,
          text:  x.name
        }
      })
    },
    setAllUnits(state, payload) {
      const convertedAllUnits = payload.allUnits.map((unit, index)=>{
        const children = Object.entries(payload.allUnits[index].children)
          .map(([, child])=>{
            return {
              text: child.name,
              shortText: child.short_name,
              disabledFlag: child.disabled_flag,
              value: child.id, //単元ID
              parentId: child.parent_id,
              checked: false
            }
          })

        return {
          id: unit.id,
          value: index+1,
          text:  unit.name,
          shortText: unit.short_name,
          gradeId: unit.grade_id,
          publisherId: unit.publisher_id,
          isShow: false,
          isAllSelected: false,
          disabledFlag: unit.disabled_flag,
          children: children
        }
      })

      state.allUnits = convertedAllUnits
    },

    setAllThemes(state, payload) {
      const convertedAllTheme = payload.allThemes.map((theme, index)=>{
        const children = Object.entries(payload.allThemes[index].children)
          .map(([, child])=>{
            return {
              text: child.name,
              value: child.id,
              parentId: child.parent_id,
              checked: false
            }
          })

        return {
          id: theme.id,
          value: index+1,
          text:  theme.name,
          isShow: false,
          isAllSelected: false,
          children: children
        }
      })

      state.allThemes = convertedAllTheme
    },
  },

  actions: {
    //マスタデータ取得
    async getMasterData(store) {
      const api = axios.create()
      // 並列処理を行う
      await axios.all([
        api.get('/api/v1/materials'),          //教材
        api.get('/api/v1/grades'),             //学年
        api.get('/api/v1/publishers'),         //教科書
        api.get('/api/v1/inflectional_forms'), //活用系
        api.get('/api/v1/speech_parts'),       //品詞
        api.get('/api/v1/units'),              //単元
        api.get('/api/v1/themes'),             //テーマ
      ]).then( axios.spread( (res1, res2, res3, res4, res5, res6, res7) => {

        // 各種マスタ情報をstoreに格納
        store.commit('setAllMaterials',         {allMaterials:         res1.data })
        store.commit('setAllGrades',            {allGrades:            res2.data })
        store.commit('setAllPublishers',        {allPublishers:        res3.data })
        store.commit('setAllInflectionalForms', {allInflectionalForms: res4.data })
        store.commit('setAllSpeechParts',       {allSpeechParts:       res5.data })
        store.commit('setAllUnits',             {allUnits:             res6.data })
        store.commit('setAllThemes',            {allThemes:            res7.data })
      }))
    },
  },
}
